var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-list-item",
        [
          _c(
            "w-list-item-icon",
            [_c("w-fa", { attrs: { icon: _vm.icon } })],
            1
          ),
          _c("w-list-item-text", [
            _vm._v(" " + _vm._s(_vm.$ct(_vm.columnName)) + " "),
          ]),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("edit-column"),
                      expression: "$ct('edit-column')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("remove-column"),
                      expression: "$ct('remove-column')",
                    },
                  ],
                  staticClass: "danger",
                  attrs: { disabled: !_vm.canDelete },
                  on: {
                    click: function ($event) {
                      return _vm.remove()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-transition-slide-height",
        [
          _vm.isEditing
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-column-select", {
                        attrs: {
                          browse: _vm.browse,
                          value: _vm.col,
                          "is-server-column": "",
                          "nummeric-only": "",
                          model: _vm.model,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setColumn($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("is-negative") },
                        model: {
                          value: _vm.column.IsNegative,
                          callback: function ($$v) {
                            _vm.$set(_vm.column, "IsNegative", $$v)
                          },
                          expression: "column.IsNegative",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }